import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {
  QUOTE_PARSE_EVENTS_BRIDGE,
  QuoteParseEventPayload,
  QuoteParseEventsBridge
} from 'sustainment-component';

export type QuoteParsedEvent = {
  sustainmentId: string;
  projectExternalId: string;
  quoteId: number;
  quoteName: string;
};

@Injectable({ providedIn: 'root' })
export class QuoteParseEventsBridgeService implements QuoteParseEventsBridge {
  private _quoteParsedSubject = new Subject<QuoteParsedEvent>();
  public readonly quoteParsed$: Observable<QuoteParsedEvent> =
    this._quoteParsedSubject.asObservable();

  private _quoteParseFailedSubject = new Subject<QuoteParsedEvent>();
  public readonly quoteParseFailed$: Observable<QuoteParsedEvent> =
    this._quoteParseFailedSubject.asObservable();

  private _quoteReadyToCompareSubject = new Subject<QuoteParsedEvent>();
  public readonly quoteReadyToCompare$: Observable<QuoteParsedEvent> =
    this._quoteReadyToCompareSubject.asObservable();

  public quoteParsed(payload: QuoteParseEventPayload): void {
    const normalized: QuoteParsedEvent = {
      sustainmentId: String(payload.sustainmentId),
      projectExternalId: String(payload.projectExternalId),
      quoteId: Number(payload.quoteId),
      quoteName: String(payload.quoteName)
    };
    this._quoteParsedSubject.next(normalized);
  }

  public quoteParseFailed(payload: QuoteParseEventPayload): void {
    const normalized: QuoteParsedEvent = {
      sustainmentId: String(payload.sustainmentId),
      projectExternalId: String(payload.projectExternalId),
      quoteId: Number(payload.quoteId),
      quoteName: String(payload.quoteName)
    };
    this._quoteParseFailedSubject.next(normalized);
  }


  public quoteReadyToCompare(payload: QuoteParseEventPayload): void {
    const normalized: QuoteParsedEvent = {
      sustainmentId: String(payload.sustainmentId),
      projectExternalId: String(payload.projectExternalId),
      quoteId: Number(payload.quoteId),
      quoteName: String(payload.quoteName)
    };
    this._quoteReadyToCompareSubject.next(normalized);
  }
}
